/*
 * DO NOT EDIT
 * ===========
 * This file was auto-generated.
 * To update run the TypeScript Code Generator in the API.
 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { REGIME_PLACEHOLDER } from '@assetaccountant/core/http-token.interceptor';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { CreateDepreciationMethodCommand } from '../models/depreciation/create-depreciation-method.command';
import { GetDepreciationMethodResponse } from '../models/depreciation/get-depreciation-method.response';
import { GetRateAndRemainingLifeQuery } from '../models/depreciation/get-rate-and-remaining-life.query';
import { GetRateAndRemainingLifeResponse } from '../models/depreciation/get-rate-and-remaining-life.response';
import { PatchDepreciationMethodCommand } from '../models/depreciation/patch-depreciation-method.command';
import { RegimeDepreciationMethodsDto } from '../models/regime-depreciation-methods.dto';
import { RegimeSettingDto } from '../models/regime-setting.dto';

@Injectable({
  providedIn: 'root',
})
export class DepreciationApi {
  constructor(private http: HttpClient) {}

  createMethod(query: CreateDepreciationMethodCommand): Observable<void> {
    return this.http.post<void>(`${environment.servicesApiUrl}/api/v1/depreciation/methods`, query);
  }

  get(): Observable<RegimeDepreciationMethodsDto[]> {
    return this.http.get<RegimeDepreciationMethodsDto[]>(
      `${environment.servicesApiUrl}/api/v1/depreciation/method-list`,
    );
  }

  getMethod(depreciationMethodKey: string): Observable<GetDepreciationMethodResponse> {
    return this.http.get<GetDepreciationMethodResponse>(
      `${environment.servicesApiUrl}/api/v1/depreciation/methods/${depreciationMethodKey}`,
    );
  }

  getRate(query: GetRateAndRemainingLifeQuery = {}): Observable<GetRateAndRemainingLifeResponse> {
    return this.http.get<GetRateAndRemainingLifeResponse>(
      `${environment.servicesApiUrl}/api/v1/depreciation/rate`,
      {
        params: {
          ...(query.regimeId ? { regimeId: query.regimeId } : {}),
          ...(query.depreciationMethodId
            ? { depreciationMethodId: query.depreciationMethodId }
            : {}),
          ...(query.life ? { life: query.life } : {}),
          ...(query.endDate ? { endDate: query.endDate } : {}),
          ...(query.date ? { date: query.date } : {}),
          ...(query.firstUseDate ? { firstUseDate: query.firstUseDate } : {}),
        },
      },
    );
  }

  getRegimeSettings(options: { regimeId?: number } = {}): Observable<RegimeSettingDto[]> {
    return this.http.get<RegimeSettingDto[]>(
      `${environment.servicesApiUrl}/api/v1/depreciation/${options.regimeId ?? REGIME_PLACEHOLDER}/settings`,
    );
  }

  getRegimeSettingsOld(): Observable<RegimeSettingDto[]> {
    return this.http.get<RegimeSettingDto[]>(
      `${environment.servicesApiUrl}/api/v1/depreciation/regime-settings`,
    );
  }

  updateMethod(command: PatchDepreciationMethodCommand): Observable<void> {
    return this.http.patch<void>(
      `${environment.servicesApiUrl}/api/v1/depreciation/methods/${command.depreciationMethodKey}`,
      command,
    );
  }
}
